import PageLayout from 'pages/ViewRubric/PageLayout';
import PageProvider from 'pages/ViewRubric/PageProvider';

const ViewRubricPage = ({ ...props }) => {
    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default ViewRubricPage;
